package com.nonopn.skywatcher.common.app.pages.map.window

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.pages.map.model.MainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.view.AlertBanner
import com.nonopn.skywatcher.common.app.pages.map.view.MainColumn
import com.nonopn.skywatcher.common.app.pages.map.view.Map

@Composable
fun MainScreenLargeScreen(
    modifier: Modifier,
    model: MainScreenModel
) {
    Row(modifier) {
        MainColumn(Modifier.width(250.dp).fillMaxHeight(), model)

        Column(Modifier.weight(1.0f)) {
            Map(Modifier.fillMaxWidth().weight(1.0f), model)

            AlertBanner(Modifier.fillMaxWidth().height(200.dp), model)
        }
    }
}